import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from '@assets/scss/components/info-list.module.scss'
import descStyle from './styles.module.scss'

import CustomLink from '@shared/components/customLink'
import { TwitterImg, WikipediaImg, InstaImg, FbImage } from '@shared/components/ctIcons'

const TeamInfo = ({ data }) => {
  const [showMore, setShowMore] = useState(true)
  const handleDesc = () => {
    setShowMore(!showMore)
  }
  return (
    <>
      <h3 className="small-head">{'Team Info'}</h3>
      <row>
        <section>
          <div className={`${styles.list} ${descStyle.containerInfo} font-semi mb-4 common-box p-3 overflow-hidden`}>
            {
              (data?.oSocialMedia?.oFacebook?.sHandle || data?.oSocialMedia?.oInstagram?.sHandle || data?.oSocialMedia?.oWikipedia?.sHandle || data?.oSocialMedia?.oTwitter?.sHandle) && (
                <div className={`${styles.item} d-flex w-100`}>
                  <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0`}>
                    Socials
                  </p>
                  <div className='w-100 d-flex flex-wrap gap-3'>
                    {data?.oSocialMedia?.oWikipedia?.sHandle &&
                      <div className={`${descStyle.socialPill} d-flex`}>
                        <div className={`${descStyle.socialIcon}`}>
                          <WikipediaImg />
                        </div>
                        <div className={`${descStyle.socialTag}`}>
                          <CustomLink href={`${data?.oSocialMedia?.oWikipedia?.sUrl}`}>
                            <a target="_blank">{data?.oSocialMedia?.oWikipedia?.sHandle}</a>
                          </CustomLink>
                        </div>
                      </div>}
                    {data?.oSocialMedia?.oInstagram?.sHandle &&
                      <div className={`${descStyle.socialPill} d-flex`}>
                        <div className={`${descStyle.socialIcon}`}>
                          <InstaImg />
                        </div>
                        <div className={`${descStyle.socialTag}`}>
                          <CustomLink href={`${data?.oSocialMedia?.oInstagram?.sUrl}`}>
                            <a target="_blank">{data?.oSocialMedia?.oInstagram?.sHandle}</a>
                          </CustomLink>
                        </div>
                      </div>
                    }
                    {data?.oSocialMedia?.oFacebook?.sHandle &&
                      <div className={`${descStyle.socialPill} d-flex`}>
                        <div className={`${descStyle.socialIcon}`}>
                          <FbImage />
                        </div>
                        <div className={`${descStyle.socialTag}`}>
                          <CustomLink href={`${data?.oSocialMedia?.oFacebook?.sUrl}`}>
                            <a target="_blank">{data?.oSocialMedia?.oFacebook?.sHandle}</a>
                          </CustomLink>
                        </div>
                      </div>}
                    {data?.oSocialMedia?.oTwitter?.sHandle &&
                      <div className={`${descStyle.socialPill} d-flex`}>
                        <div className={`${descStyle.socialIcon}`}>
                          <TwitterImg />
                          {/* <MyImage
                              src={twitter}
                              alt='Twitter'
                              layout="responsive"
                              width="32"
                              height="32"
                            /> */}
                        </div>
                        <div className={`${descStyle.socialTag}`}>
                          <CustomLink href={data?.oSocialMedia?.oTwitter?.sUrl}>
                            <a target="_blank">{data?.oSocialMedia?.oTwitter?.sHandle}</a>
                          </CustomLink>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              )
            }
            {
              data?.sContent && (
                <row>
                  <div className={`${(data?.oSocialMedia?.oFacebook?.sHandle || data?.oSocialMedia?.oInstagram?.sHandle || data?.oSocialMedia?.oWikipedia?.sHandle || data?.oSocialMedia?.oTwitter?.sHandle) && descStyle.borderTop}`}>
                    <div className={`${styles.item} ${styles.list}  ${descStyle.dBlock} d-flex`}>
                      <p className={`${styles.label} ${descStyle.textLightMuted} ${descStyle.w_100} mb-0 flex-shrink-0 text-muted mb-2`}>
                        About
                      </p>
                      <div>
                        <div className={`${descStyle.aboutCntr} ${descStyle.pl_0}  ${showMore ? descStyle.readMore : ''} fw-bold`}>
                          {showMore ? (
                            <div dangerouslySetInnerHTML={{ __html: data?.sContent.slice(0, 400) }} />
                          ) : (
                            <div dangerouslySetInnerHTML={{ __html: data?.sContent }} />
                          )}
                        </div>
                        <span onClick={handleDesc}>
                          {
                            data?.sContent?.length > 400 && (
                              <>
                                {
                                  showMore ? <a className={`${descStyle.readBtn} fw-bold`}>...Read More</a> : <a className={`${descStyle.readBtn} fw-bold`}>Read Less</a>
                                }
                              </>
                            )
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </row>
              )
            }
          </div>
        </section>
      </row>
    </>
  )
}

TeamInfo.propTypes = {
  data: PropTypes.object
}

export default TeamInfo
